import React from 'react'
import { Link } from 'react-router-dom'
import SidebarLogout from './SidebarLogout'
import SidebarCloseButton from './SidebarCloseButton'

export default function DoctorMenu() {
  return (
    <>
     <aside className="main-sidebar">
        <section className="sidebar position-relative">
          <SidebarCloseButton />
          <div className="multinav">
            <div className="multinav-scroll">
              <ul className="sidebar-menu menu-font" data-widget="tree">
                <li>
                  <Link to="/doctor-dashboard">
                    <i className="icon-Layout-4-blocks">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Dashboard</span>
                   
                  </Link>
                  
                </li>
                <li>
                  <Link to="/add-case">
                    <i className="icon-Barcode-read">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Add New Case</span>
                  </Link>
                </li>
                <li>
                  <Link to="/draft-cases">
                    <i className="icon-Compiling">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Draft Cases</span>
                    
                  </Link> 
                  
                </li>

                <li>
                <Link to="/view-cases?r_type=patient">
                    <i className="icon-Compiling">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">View Submitted Cases</span>
                    
                  </Link> 
                  
                </li>
               

               
               
                {/* <li>
                  <a href="reports.html">
                    <i className="icon-Settings-1">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Home BP Monitoring Study</span>
                  </a>
                </li> */}
                <li className="">
                  <Link to="/instructions">
                    <i className="icon-Diagnostics">
                      <span className="path1"></span>
                      <span className="path2"></span>
                      <span className="path3"></span>
                    </i>
                    <span className="sidebar-menu__label">Study Protocol</span> 
                  </Link>
                   
                </li>
                {/* <li className="header">Reports</li> */}
                <li >
                  <Link to="/contact">
                    <i className="icon-Library">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Contact</span> 
                  </Link>
                  
                </li>
                <li>
                  <Link to="/change-password">
                    <i className="icon-Lock-overturning">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Change Password</span>
                  </Link>
                </li>
                {/* <li >
                  <a href="#">
                    <i className="icon-Library">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">FAQ</span> 
                  </a>
                  
                </li> */}
                
                 
                
              </ul>
              <SidebarLogout />
            </div>
          </div>
        </section>
      </aside>
    </>
  )
}
